import React from "react";
import CheckBox from "../../../../CheckBox/CheckBox";

const MassageTherapy = ({ massageCardsData, setMassageCardsData }) => {
  return (
    <div className="h-[450px] overflow-x-auto overflow-y-hidden md:overflow-x-visible rounded-xl">
      <div>
        <div className="border-[#D9D9D9] border border-solid rounded-xl shadow-[0px_0px_7px_#00000040] w-[665px]">
          <div className="h-[64px] bg-[#D9D9D9] border-b-2 rounded-t-xl border-b-solid border-b-[#8C8C8C] grid grid-cols-5">
            <div className="w-[88px] h-[40px]">
              <p className="font-font-Titillium font-bold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase pt-4 pb-2 pl-4">
                Focus Area
              </p>
            </div>
          </div>
          <div className="h-[56px] border border-b-solid border-b-[#D9D9D9] flex items-center">
            <div className="w-[101px] h-[40px] flex items-center">
              <p className="font-font-Titillium font-semibold text-[16px] leading-[19.2px] tracking-[0.0156em] pl-4">
                Head, neck & shoulders
              </p>
            </div>
          </div>
          <div className="h-[56px] border border-b-solid border-b-[#D9D9D9] flex items-center">
            <div className="w-[101px] h-[40px] flex items-center">
              <p className="font-font-Titillium font-semibold text-[16px] leading-[19.2px] tracking-[0.0156em] pl-4">
                Full back
              </p>
            </div>
          </div>
          <div className="h-[56px] border border-b-solid border-b-[#D9D9D9] flex items-center">
            <div className="w-[101px] h-[40px] flex items-center">
              <p className="font-font-Titillium font-semibold text-[16px] leading-[19.2px] tracking-[0.0156em] pl-4">
                Lower back & glutes
              </p>
            </div>
          </div>
          <div className="h-[56px] border border-b-solid border-b-[#D9D9D9] flex items-center">
            <div className="w-[101px] h-[40px] flex items-center">
              <p className="font-font-Titillium font-semibold text-[16px] leading-[19.2px] tracking-[0.0156em] pl-4">
                Thighs & legs
              </p>
            </div>
          </div>
        </div>
        <div className="border-[#D9D9D9] border border-solid rounded-xl shadow-[0px_0px_7px_#00000040] my-2 w-[665px]">
          <div className="h-[64px] flex items-center">
            <div className="w-[88px] h-[40px] flex items-center">
              <p className="font-font-Titillium font-semibold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase pl-4">
                Frequency
              </p>
            </div>
          </div>
        </div>
        <div className="border-[#D9D9D9] border border-solid rounded-xl shadow-[0px_0px_7px_#00000040] my-2 w-[665px]">
          <div className="h-[64px] flex items-center">
            <div className="w-[88px] h-[40px] flex items-center">
              <p className="font-font-Titillium font-semibold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase pl-4">
                Total Charge:
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="relative left-28 top-[-27.3rem] w-[550px]">
        <div className="flex">
          {massageCardsData?.map((item, index) => (
            <div className="bg-[#f5f5f599] border-[0.5px] border-solid border-[#8C8C8C] shadow-[0px_0px_6px_#00000040] rounded-2xl h-[420px] w-[125px] mx-2">
              <div className="h-[51px] border-b-2 border-b-solid border-b-[#8C8C8C]">
                <p className="font-font-Titillium font-semibold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase pt-1 mt-1 pb-1 text-center">
                  {item?.name}
                </p>
              </div>
              <div className="flex items-center justify-center h-[56px]">
                <div class="flex items-center">
                  <CheckBox
                    id="terms"
                    onChecked={(e) => {
                      console.log("e:", e);
                      const data = massageCardsData?.map((item, i) => {
                        if (i !== index) return item;
                        return {
                          ...item,
                          headNeck: {
                            ...item?.headNeck,
                            isChecked: e,
                          },
                          charge: e
                            ? item?.charge +
                              item?.headNeck?.price *
                                (item?.frequency?.includes("twice") ? 2 : 1)
                            : item?.charge -
                              item?.headNeck?.price *
                                (item?.frequency?.includes("twice") ? 2 : 1),
                        };
                      });
                      setMassageCardsData(data);
                    }}
                    isChecked={item?.headNeck?.isChecked}
                  />
                  <label
                    for="yellow-checkbox"
                    class="ml-2 text-sm font-medium text-gray-900"
                  >
                    £{item?.headNeck?.price}
                  </label>
                </div>
              </div>
              <div className="flex items-center justify-center h-[56px]">
                <div class="flex items-center">
                  <CheckBox
                    id="terms"
                    onChecked={(e) => {
                      const data = massageCardsData?.map((item, i) => {
                        if (i !== index) return item;
                        return {
                          ...item,
                          fullBack: {
                            ...item?.fullBack,
                            isChecked: e,
                          },
                          charge: e
                            ? item?.charge +
                              item?.fullBack?.price *
                                (item?.frequency?.includes("twice") ? 2 : 1)
                            : item?.charge -
                              item?.fullBack?.price *
                                (item?.frequency?.includes("twice") ? 2 : 1),
                        };
                      });
                      setMassageCardsData(data);
                    }}
                    isChecked={item?.fullBack?.isChecked}
                  />
                  <label
                    for="yellow-checkbox"
                    class="ml-2 text-sm font-medium text-gray-900"
                  >
                    £{item?.fullBack?.price}
                  </label>
                </div>
              </div>
              <div className="flex items-center justify-center h-[56px]">
                <div class="flex items-center">
                  <CheckBox
                    id="terms"
                    onChecked={(e) => {
                      const data = massageCardsData?.map((item, i) => {
                        if (i !== index) return item;
                        return {
                          ...item,
                          lowerBack: {
                            ...item?.lowerBack,
                            isChecked: e,
                          },
                          charge: e
                            ? item?.charge +
                              item?.lowerBack?.price *
                                (item?.frequency?.includes("twice") ? 2 : 1)
                            : item?.charge -
                              item?.lowerBack?.price *
                                (item?.frequency?.includes("twice") ? 2 : 1),
                        };
                      });
                      setMassageCardsData(data);
                    }}
                    isChecked={item?.lowerBack?.isChecked}
                  />
                  <label
                    for="yellow-checkbox"
                    class="ml-2 text-sm font-medium text-gray-900"
                  >
                    £{item?.lowerBack?.price}
                  </label>
                </div>
              </div>
              <div className="flex items-center justify-center h-[56px]">
                <div class="flex items-center">
                  <CheckBox
                    id="terms"
                    onChecked={(e) => {
                      const data = massageCardsData?.map((item, i) => {
                        if (i !== index) return item;
                        return {
                          ...item,
                          thighLegs: {
                            ...item?.thighLegs,
                            isChecked: e,
                          },
                          charge: e
                            ? item?.charge +
                              item?.thighLegs?.price *
                                (item?.frequency?.includes("twice") ? 2 : 1)
                            : item?.charge -
                              item?.thighLegs?.price *
                                (item?.frequency?.includes("twice") ? 2 : 1),
                        };
                      });
                      setMassageCardsData(data);
                    }}
                    isChecked={item?.thighLegs?.isChecked}
                  />
                  <label
                    for="yellow-checkbox"
                    class="ml-2 text-sm font-medium text-gray-900"
                  >
                    £{item?.thighLegs?.price}
                  </label>
                </div>
              </div>
              <div className="h-[83px] flex flex-col justify-center">
                <div className="ml-3">
                  <form>
                    <div class="grids grid-cols-12 justify-center">
                      <input
                        id="yellow-radio"
                        type="radio"
                        value="once"
                        name="colored-radio"
                        class="w-4 h-4 text-[#FAAD14] bg-gray-100 border-gray-300 focus:ring-[#FAAD14] focus:ring-0"
                        checked={
                          item?.frequency?.includes("once") ? true : false
                        }
                        onChange={(e) => {
                          const data = massageCardsData?.map((item, i) => {
                            if (i !== index) return item;
                            return {
                              ...item,
                              frequency: e?.target?.value,
                              charge:
                                (item.headNeck.isChecked
                                  ? item.headNeck.price
                                  : 0) +
                                (item.fullBack.isChecked
                                  ? item.fullBack.price
                                  : 0) +
                                (item.lowerBack.isChecked
                                  ? item.lowerBack.price
                                  : 0) +
                                (item.thighLegs.isChecked
                                  ? item.thighLegs.price
                                  : 0),
                            };
                          });
                          setMassageCardsData(data);
                        }}
                      />
                      <label
                        for="yellow-radio"
                        class="ml-2 text-sm font-medium text-gray-900 "
                      >
                        Once a week
                      </label>
                    </div>
                    <div class="grids grid-cols-12 justify-center">
                      <input
                        id="yellow-radio"
                        type="radio"
                        value="twice"
                        name="colored-radio"
                        class="w-4 h-4 text-[#FAAD14] bg-gray-100 border-gray-300 focus:ring-[#FAAD14] focus:ring-0"
                        checked={
                          item?.frequency?.includes("twice") ? true : false
                        }
                        onChange={(e) => {
                          const data = massageCardsData?.map((item, i) => {
                            if (i !== index) return item;
                            return {
                              ...item,
                              frequency: e?.target?.value,
                              charge: item?.charge * 2,
                            };
                          });
                          setMassageCardsData(data);
                        }}
                      />
                      <label
                        for="yellow-radio"
                        class="ml-2 text-sm font-medium text-gray-900 "
                      >
                        Twice a week
                      </label>
                    </div>
                  </form>
                </div>
              </div>
              <div className="flex items-center justify-center h-[56px]">
                <p className="font-font-Titillium font-semibold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase mt-4">
                  £{item?.charge}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MassageTherapy;
